import { IMAGE_BASE_URL } from '../../student/scratch-and-win/AppConfig';
export const giftIcon = `${IMAGE_BASE_URL}home/giftIcon.svg`;
export const BG_header = `${IMAGE_BASE_URL}home/BG_header.svg`;
export const Bullet = `${IMAGE_BASE_URL}ui/Bullet.svg`;
export const TnC = `${IMAGE_BASE_URL}ui/TnC.svg`;
export const infoBlack = `${IMAGE_BASE_URL}ui/infoBlack.svg`;

export const info = `${IMAGE_BASE_URL}win/info.svg`;

export default giftIcon;
